import { Dealer } from "@/modules/dealer";
import type { DealerFilterKey, DealerFilterPermissionsConfig } from "@/modules/config";

export { type Dealer } from "@/modules/dealer/types";
export const STATUS_OPTIONS = ["All", "Active", "Cancelled", "New"];

// Map display names to API values
export const STATUS_DISPLAY_TO_API: Record<string, string> = {
    Cancelled: "C",
    Active: "A",
    New: "N",
};

export const STATUS_API_TO_DISPLAY: Record<string, string> = {
    Inactive: "Cancelled",
    Active: "Active",
    New: "New",
};

export interface DealerSearchInputProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    statusFilter: string[];
    onStatusChange: (values: string[]) => void;
    isExpanded: boolean;
    visibleDealers: Dealer[];
    highlightIndex: number;
    onHighlightChange: (index: number) => void;
    onSelect: (dealer: Dealer) => void;
}

export interface DealerResultsProps {
    loading: boolean;
    error: string | null;
    visibleDealers: Dealer[];
    highlightIndex: number;
    onHighlightChange: (index: number) => void;
    onSelect: (dealer: Dealer) => void;
}

export interface ResultsFoundSectionProps {
    loading: boolean;
    searchTerm: string;
    showFilterResults: boolean;
    statusFilterLength: number;
    error: string | null;
    filteredDealersCount: number;
    onShowAllResults: () => void;
    onRetry: () => void;
}

export type { DealerFilterKey, DealerFilterPermissionsConfig };

export interface DealerFilters {
    oem: string[];
    product: string[];
    group: string[];
    program: string[];
    state: string[];
}

export interface FilterDropdownProps {
    label: string;
    values: string[];
    options: string[];
    onChange: (values: string[]) => void;
}

export interface DealerFiltersProps {
    filters: DealerFilters;
    filterOptions: DealerFilters;
    onFilterChange: (key: DealerFilterKey, values: string[]) => void;
    permissionsMap: DealerFilterPermissionsConfig | null;
}
